import { createSlice } from "@reduxjs/toolkit";



export const backgroundEffectSlice = createSlice({
    name: 'bgEffect',
    initialState: {
        bgPath: 'ms'
    },
    reducers: {
        changePath: (state, action) => {
            state.bgPath = action.payload
        }
    }
})


export const { changePath } = backgroundEffectSlice.actions
export default backgroundEffectSlice.reducer